(function () {
  function animationGroup(animations) {
    return {
      finished: Promise.all(animations.map(function (animation) {
        return animation.finished.catch(function () {});
      })),
      finish: function () {
        animations.forEach(function (animation) { animation.finish(); });
      }
    };
  }

  function configurePremiumDrawerMotion() {
    var drawer = document.getElementById("cart-drawer");

    if (!drawer || drawer.dataset.premiumMotionReady === "true") return;

    if (!drawer.shadowRoot) {
      window.customElements.whenDefined("cart-drawer").then(configurePremiumDrawerMotion);
      return;
    }

    drawer.dataset.premiumMotionReady = "true";

    drawer.createEnterAnimationControls = function () {
      var overlay = this.shadowRoot.querySelector('[part="overlay"]');
      var content = this.shadowRoot.querySelector('[part="content"]');
      var recommendations = this.querySelector(".cart-drawer__recommendations");
      var desktop = window.matchMedia("(min-width: 1200px)").matches;
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var duration = reducedMotion ? 1 : 800;
      var animations = [];

      content.style.marginInlineStart = "auto";

      if (overlay) {
        animations.push(overlay.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: reducedMotion ? 1 : 520, easing: "cubic-bezier(.2, .8, .2, 1)", fill: "both" }
        ));
      }

      animations.push(content.animate(
        [
          { transform: "translate3d(100%, 0, 0)", offset: 0 },
          { transform: "translate3d(-4px, 0, 0)", offset: .9 },
          { transform: "translate3d(0, 0, 0)", offset: 1 }
        ],
        { duration: duration, easing: "cubic-bezier(.2, .8, .2, 1)", fill: "both" }
      ));

      if (desktop && recommendations) {
        animations.push(recommendations.animate(
          [
            { opacity: 0, transform: "translate3d(100%, 0, 0)" },
            { opacity: 1, transform: "translate3d(-3px, 0, 0)", offset: .88 },
            { opacity: 1, transform: "translate3d(0, 0, 0)" }
          ],
          {
            delay: reducedMotion ? 0 : 670,
            duration: reducedMotion ? 1 : 520,
            easing: "cubic-bezier(.2, .8, .2, 1)",
            fill: "both"
          }
        ));
      }

      return animationGroup(animations);
    };

    drawer.createLeaveAnimationControls = function () {
      var overlay = this.shadowRoot.querySelector('[part="overlay"]');
      var content = this.shadowRoot.querySelector('[part="content"]');
      var recommendations = this.querySelector(".cart-drawer__recommendations");
      var desktop = window.matchMedia("(min-width: 1200px)").matches;
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var contentDelay = desktop && !reducedMotion ? 230 : 0;
      var animations = [];

      if (desktop && recommendations) {
        animations.push(recommendations.animate(
          [
            { opacity: 1, transform: "translate3d(0, 0, 0)" },
            { opacity: 0, transform: "translate3d(100%, 0, 0)" }
          ],
          { duration: reducedMotion ? 1 : 300, easing: "cubic-bezier(.4, 0, .6, 1)", fill: "both" }
        ));
      }

      animations.push(content.animate(
        [
          { transform: "translate3d(0, 0, 0)" },
          { transform: "translate3d(100%, 0, 0)" }
        ],
        {
          delay: contentDelay,
          duration: reducedMotion ? 1 : 640,
          easing: "cubic-bezier(.4, 0, .2, 1)",
          fill: "both"
        }
      ));

      if (overlay) {
        animations.push(overlay.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          {
            delay: contentDelay,
            duration: reducedMotion ? 1 : 460,
            easing: "ease-out",
            fill: "both"
          }
        ));
      }

      return animationGroup(animations);
    };
  }

  configurePremiumDrawerMotion();

  function getCards(track) {
    return Array.prototype.slice.call(track.querySelectorAll("[data-cart-upsell-personal-card]"));
  }

  function getActiveIndex(track) {
    var cards = getCards(track);
    var activeIndex = 0;
    var smallestDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.offsetLeft - track.scrollLeft);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function updateDots(upsell) {
    var track = upsell.querySelector("[data-cart-upsell-personal-track]");
    var dots = Array.prototype.slice.call(upsell.querySelectorAll("[data-cart-upsell-personal-dot]"));

    if (!track || dots.length === 0) {
      return;
    }

    var activeIndex = getActiveIndex(track);

    dots.forEach(function (dot, index) {
      dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
    });
  }

  function scrollToIndex(track, index) {
    var cards = getCards(track);
    var targetCard = cards[index];

    if (!targetCard) {
      return;
    }

    track.scrollTo({
      left: targetCard.offsetLeft,
      behavior: "smooth"
    });
  }

  document.addEventListener("click", function (event) {
    var arrow = event.target.closest(".cart-upsell-personal__arrow");
    var dot = event.target.closest("[data-cart-upsell-personal-dot]");

    if (!arrow && !dot) {
      return;
    }

    var upsell = event.target.closest(".cart-upsell-personal");
    var track = upsell && upsell.querySelector("[data-cart-upsell-personal-track]");

    if (!track) {
      return;
    }

    if (arrow) {
      var direction = arrow.classList.contains("cart-upsell-personal__arrow--prev") ? -1 : 1;
      var cards = getCards(track);
      var targetIndex = (getActiveIndex(track) + direction + cards.length) % cards.length;

      scrollToIndex(track, targetIndex);
    }

    if (dot) {
      var dots = Array.prototype.slice.call(upsell.querySelectorAll("[data-cart-upsell-personal-dot]"));
      scrollToIndex(track, dots.indexOf(dot));
    }
  });

  document.addEventListener("scroll", function (event) {
    var track = event.target.closest && event.target.closest("[data-cart-upsell-personal-track]");

    if (!track) {
      return;
    }

    var upsell = track.closest(".cart-upsell-personal");

    window.requestAnimationFrame(function () {
      updateDots(upsell);
    });
  }, true);

  function setAddButtonState(button, state) {
    if (!button) return;

    if (!button.dataset.idleLabel) {
      button.dataset.idleLabel = button.getAttribute("aria-label") || "Add to cart";
    }

    button.classList.toggle("is-adding", state === "adding");
    button.classList.toggle("is-added", state === "added");
    button.setAttribute("data-add-state", state);
    button.setAttribute("aria-label", state === "adding" ? "Adding to cart" : state === "added" ? "Added to cart" : button.dataset.idleLabel);
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest(".cart-upsell-personal-card__form form");

    if (!form) return;

    setAddButtonState(event.submitter || form.querySelector(".cart-upsell-personal-card__button"), "adding");
  });

  document.addEventListener("variant:add", function (event) {
    var form = event.target.closest && event.target.closest(".cart-upsell-personal-card__form form");

    if (!form) return;

    var button = form.querySelector(".cart-upsell-personal-card__button");
    setAddButtonState(button, "added");

    window.setTimeout(function () {
      if (button && button.isConnected) setAddButtonState(button, "idle");
    }, 1600);
  });

  document.addEventListener("cart:error", function (event) {
    var form = event.target.closest && event.target.closest(".cart-upsell-personal-card__form form");

    if (form) setAddButtonState(form.querySelector(".cart-upsell-personal-card__button"), "idle");
  });

  document.addEventListener("cart-drawer:refreshed", function (event) {
    event.target.querySelectorAll(".cart-upsell-personal").forEach(updateDots);
  });

  document.querySelectorAll(".cart-upsell-personal").forEach(updateDots);
})();
